import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { AuthActions } from '../../../components/auth/auth.actions';
import { LWBPeriscopeActions } from './periscope.actions';

/**
 * @description LWBPeriscope Effects.
 * @exports
 * @class LWBPeriscopeEffects
 */
@Injectable()
export class LWBPeriscopeEffects {
  private readonly actions = inject(Actions);

  readonly onAuthLogout = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.logout),
        map(() => LWBPeriscopeActions.reset())
      );
    },
    { dispatch: true }
  );

  readonly onSwitchProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.switchProfile),
        map(() => LWBPeriscopeActions.reset())
      );
    },
    { dispatch: true }
  );
}
